/**
 * Jobie-inspired light theme — warm cream paper, orange accent, pastel chart colors.
 *
 * Reference: Jobie Admin Dashboard (ThemeForest 28812680).
 * Strict-neon palette superseded 2026-04-25 per user request.
 */
export const tokensV2 = {
  surface: {
    canvas:        "#FBF7F2",
    card:          "#FFFFFF",
    cardHover:     "#FFF9F2",
    elevated:      "#FFFFFF",
  },
  border: {
    subtle:  "rgba(31,42,63,0.08)",
    default: "rgba(31,42,63,0.12)",
    strong:  "rgba(31,42,63,0.20)",
  },
  brand: {
    base: "#FC8019",
    soft: "rgba(252,128,25,0.12)",
    deep: "#FF6B35",
    deepSoft: "rgba(255,107,53,0.12)",
  },
  status: {
    good:    "#4CAF50",
    bad:     "#FF4757",
    warn:    "#FFC107",
    goodBg:  "rgba(76,175,80,0.10)",
    badBg:   "rgba(255,71,87,0.10)",
    warnBg:  "rgba(255,193,7,0.10)",
  },
  chart: {
    orange: "#FC8019",
    teal:   "#2EC4B6",
    violet: "#7C4DFF",
    pink:   "#FF6B9D",
    yellow: "#FFC107",
    mint:   "#4CAF50",
  },
  text: {
    primary:   "#1F2A3F",
    secondary: "rgba(31,42,63,0.65)",
    muted:     "rgba(31,42,63,0.45)",
  },
  font: {
    sans: '"Inter", "Plus Jakarta Sans", -apple-system, system-ui, sans-serif',
    mono: '"JetBrains Mono", ui-monospace, monospace',
    nums: '"tnum" 1, "lnum" 1, "ss01" 1',
  },
  radius: { sm: 6, md: 8, lg: 12, xl: 16 },
  space: { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, '2xl': 24, '3xl': 32 },
};
